import { ReactElement } from "react";
import { SKILLS_MATRIX_MODES } from "../../../skills-domain/shared/consts";
import { SkillsMatrix } from "../../../skills-domain/ui/user-skills-matrix";

const Skills = (): ReactElement => (
  <SkillsMatrix mode={SKILLS_MATRIX_MODES.USER_EDIT} />
);

export default Skills;
